<div class="form-group" [formGroup]="form">
    <div class="input-group">
        <input #myRangeInput class="form-control cursor-pointer" formControlName="{{filter.name}}"
            placeholder="{{ filter.placeholder }}" name="{{filter.name}}" id="{{filter.name}}"
            placeholder="DD/MM/YYYY - DD/MM/YYYY" name="dp" [(ngModel)]="model" [placement]="'bottom-right'"
            ngbDatepicker [dayTemplate]="t" [startDate]="startDate" [autoClose]="'outside'" [displayMonths]="1"
            [maxDate]="maxDate" [minDate]="minDate" #d="ngbDatepicker" autocomplete="off"
            (ngModelChange)="onInputChange($event)" (click)="d.toggle()" readonly />

        <ng-template #t let-date="date" let-focused="focused" style="left: -90px">
            <span class="custom-day" [class.range]="isFrom(date) || isTo(date) || isInside(date) || isHovered(date)"
                [class.faded]="isHovered(date) || isInside(date)" (click)="onDateSelection(date)"
                (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
                {{ date.day }}
            </span>
        </ng-template>
        <div class="clean-input" (click)="cleanInputRange()">
            <i class="fas fa-times"></i>
        </div>
        <div class="input-group-append">
            <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button"> <i class="fa fa-calendar"
                    style="cursor: pointer;"></i>
            </button>
        </div>
    </div>
</div>